import React from "react";
import styled from "styled-components";
const InputWrapper = styled.div`
select {
  height: 36px;
  border-radius: 5px;
   ${(props) => (props.error ? "border: 1px solid red" : "")};
}

  label {
    color: ${(props) => (props.error ? "red" : "")};
  }
`;

const Select = (props) => {
  const {
    data,
    value,
    onChange,
    textProperty,
    valueProperty,
    label,
    name,
    search,
    onClick,
    error,
    disabled = false,
  } = props;
  const handleOnclick = () => {
    onClick(true);
  };
  return (
    <>
    

      <InputWrapper error={error}>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="input-group">
        <select
          className="form-select"
          id={name}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
          disabled={disabled}
        >
          {data.map((item) => (
            <option key={item[valueProperty]} value={item[valueProperty]}>
              {item[textProperty]}
            </option>
          ))}
        </select>
        {search && (
          <div className="input-group-addon input-group-button col-auto mb-1 px-1">
            <button
              type="button"
              id="show-contact-modal-button"
              className="btn btn-primary"
              onClick={handleOnclick}
            >
              {search}
            </button>
          </div>
        )}
      </div>

      </InputWrapper>

      {/* {error && <div className="alert alert-danger">{error}</div>} */}
    </>
  );
};
Select.defaultProps = {
  textProperty: "name",
  valueProperty: "_id",
};
export default Select;
